import { AdminComponent } from '~/components/admin-component/admin-component';

export const Salutations = () => (
  <AdminComponent
    componentName="Salutations"
    title="Salutations"
  />
);
